import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import get from 'lodash/get';

import css from '../DDRComplete/Complete.module.scss';
import Layout from '../../components/Layout/Layout';
import AppDownloadLinks from '../DDRComplete/AppDownloadLinks.tsx';

class Complete extends Component {
  confirmationMessage() {
    let userMessage = `Open your Greenlight app to order Custom Cards, upgrade to Greenlight Infinity and Max, send your kids money, manage chores and more!`;
    if (
      this.props.role === 'approver' ||
      get(this.props, 'registeredUser.user.role') === 'approver'
    ) {
      userMessage = `You're registered as part of this account!`;
    }

    return userMessage;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (!this.props.registeredUser || !this.props.registeredUser.user) {
      this.props.setNextRegStep('phone');
    } else {
      this.props.analytics.trackEvent('Registration Complete Viewed', {
        eventProps: {
          role: this.props.registeredUser.user.role
        }
      });

      this.confirmationMessage();
    }
  }

  render() {
    return (
      <React.Fragment>
        <Layout>
          <div className={css.CompleteMainBox}>
            <h1 data-e2e="returning-message" data-testid="returning-message">
              Welcome back!
            </h1>
            <div className={css.completeImage}>
              <img
                src="../../../static/complete-custom-white.png"
                alt="Greenlight card example"
              />
            </div>
            <div className={css.CompleteBody}>
              <h3>Next stop: the Greenlight app</h3>
              <p
                data-e2e="confirm-message"
                data-testid="confirm-message"
                style={{ marginBottom: '30px', whiteSpace: 'pre-wrap' }}
              >
                {this.confirmationMessage()}
              </p>
              <p className={css.appStoreText}>Install or go to the app:</p>
              <AppDownloadLinks promoId="" partner="" />
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

export default Complete;
